import React from 'react';
import './timers.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Temporizadores'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
